import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { ThreatsService } from '../../../services/threats/threats.service';
import { Threats } from './models/Threats';
import * as actions from './threats.actions';

@Injectable()
export class ThreatsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly service: ThreatsService,
  ) {}

  getThreats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getThreats),
      exhaustMap(() =>
        this.service.getThreats().pipe(
          map((threats: Threats[]) => {
            return actions.getThreatsSuccess({ threats });
          }),
          catchError((error: any) => of(actions.getThreatsFailure(error))),
        ),
      ),
    ),
  );

  runScanTreats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.runScanThreats),
      exhaustMap(() =>
        this.service.runScan().pipe(
          map(() => {
            return actions.runScanThreatsSuccess();
          }),
          catchError((error: any) => of(actions.runScanThreatsFailure(error))),
        ),
      ),
    ),
  );

  calculateThreatRisk$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.calculateThreatRisk),
      exhaustMap((action) =>
        this.service.calculateThreatRisk(action.threatId).pipe(
          map(() => {
            return actions.calculateThreatRiskSuccess({
              threatId: action.threatId,
            });
          }),
          catchError((error: any) =>
            of(actions.calculateThreatRiskFailure(error)),
          ),
        ),
      ),
    ),
  );
}
